import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import _, {concat, reduce, some, split} from 'lodash';
import {getClassList} from "../../../../Utility/siteConfig";
import Select from "react-select";
import {buildOptions, UPSTREAM_DELIM} from "./optionsLogic";


/**
 * The heart of a ClusterLevel - the <select> widget.
 *
 *
 * @param id
 * @param value
 * @param name
 * @param cluster
 * @param choices
 * @param enabled
 * @param onSelect
 * @param upstream
 * @returns {Element}
 * @constructor
 */
export default function ItemClusterSelectWidget({
  id, value, name, cluster, choices, enabled = true, onSelect, upstream = "", productAttribute = {}
}) {
  const [skipping, setSkipping] = useState(false);

  // when 'upstream' changes, for one cycle we will skip render.
  // this prevents the Select widget from remembering our prior selection
  // and staying on that selection; we want to force it back to defaultValue.
  // the easiest way to do this is to unmount, then create another on next render.
  useEffect(() => {
    //console.log(`upstream changed for ${name}, skip next render`);
    setSkipping(true);
  }, [upstream])

  // ...and on the following cycle, clear the skipRender flag and render normally.
  useEffect(() => {
    if (skipping)
      setSkipping(false);
  }, [skipping]);

  // by skipping render we unmount the <Select> component
  if (skipping)
    return <div/>

  // console.log(`render ${name} with upstream ${upstream}`)

  // Vehicle Detail, Color, Size, etc.
  const label = (cluster.labels ? cluster.labels[name] : null) || _.capitalize(name);

  function handleSelect(choice, info) {
    // info like {action: select-option}
    // let {target = {}} = (evt || {});
    // let value = target.value || "";
    let {label, value} = choice;

    // KLUGE; to make the labels/values different if the upstream context is switched,
    // the values are tagged with ;UPSTREAM=XXX suffix. Remove before applying
    value = (value && UPSTREAM_DELIM) ? value.split(UPSTREAM_DELIM)[0] : value;

    // console.log(`SELECTED: ${value} label=${label}`);
    onSelect(value);
  }

  let options = buildOptions({choices, name, label, upstream, productAttribute});

  // https://react-select.com/styles#inner-components
  let styleFunctions = {
    option: (base, state) => {
      // whiteSpace pre-wrap is the reason we're using this widget at all!
      // this will let the linefeeds and spaces inserted by buildOptions
      // to be visible.
      return {...base, whiteSpace: 'pre-wrap'};
    },

    control: (base, state) => {
      return {...base, minHeight: '2.5rem'};
    },

    singleValue: (base, state) => {
      // also show pre-wrapped version after selection.
      return {...base, whiteSpace: 'pre-wrap'};
    },

    menu: (base, state) => {
      console.log("MENU STYLES: ", base, state);
      return {...base, left: 0, top: "-0.5rem", zIndex: 1000};
    },


  };

  //  "Select" is the react-select library.
  // use menuIsOpen=true to reveal the widget for debugging
  return <Select
    classNamePrefix="cluster-select"
    blurInputOnSelect={true}
    isSearchable={false}
    menuPlacement="bottom"
    styles={styleFunctions}
    defaultValue={options[0]}
    onChange={handleSelect}
    onMenuOpen={() => {}}
    options={options}/>
}

ItemClusterSelectWidget.propTypes = {
  name: PropTypes.string, // fitment, color, application_id
  cluster: PropTypes.object, value: PropTypes.string, // long string like "Regular Cab, with 1st Row Bench..."
  choices: PropTypes.array, enable: PropTypes.bool, onSelect: PropTypes.func
}


